<h1>Demo</h1>

<button (click)="showError()">Show full scren ERROR</button>
<button (click)="showSuccess()">Show full scren SUCCESS</button>